import { castArray } from 'lodash/fp';
import { API_URL } from '../../../app-config/constants';
import type { EmailTemplateMiniDto, EmailTemplateType } from '../../../types/EmailTemplateDto';
import { getLaddaId } from '../../../types/EmailTemplateDto';
import { get } from '../request';

getTemplates.operation = 'READ';
getTemplates.idFrom = getLaddaId;
export function getTemplates(
    types?: EmailTemplateType | EmailTemplateType[],
    options: { reviewCycleId?: string; feedbackCycleId?: string } = {}
) {
    return get<EmailTemplateMiniDto[]>(`${API_URL}/email-templates-mini`, {
        getData: {
            types: types && castArray(types).join(','),
            ...options,
        },
    });
}

invalidate.invalidates = ['getTemplates'];
export function invalidate() {
    return Promise.resolve();
}
